// extracted by mini-css-extract-plugin
export default {"title_image":"title_image_title_image__FYRgt"};